<template>
    <div class="main">
        <a-row class="container" :gutter="8">
            <a-col :span="16">
                <a-form :form="form">
                    <a-form-item label="标引标题" :label-col="{ xl: {span: 3}, xxl: {span: 2} }" :wrapper-col="{ xl: {span: 21}, xxl: {span: 22} }">
                        <a-input placeholder="请输入标引标题" size="large" v-decorator="['title',{rules: [{ required: true, message: '请输入标引标题' }]}]">
                            <a-icon slot="prefix" type="form" value="title"/>
                        </a-input>
                    </a-form-item>
                    <a-form-item label="(可选项)" :label-col="{ xl: {span: 3}, xxl: {span: 2} }" :wrapper-col="{ xl: {span: 21}, xxl: {span: 22} }">
                        <a-button type="danger" size="default" @click="chooseReport" v-if="!choosedReportName">
                            关联报题<a-icon type="right" />
                        </a-button>
                        <a-tag closable @close="deleteReportInfo" color="#1890ff" style="height: 32px;line-height: 32px;" v-else>{{choosedReportName}}</a-tag>
                    </a-form-item>
                </a-form>
            </a-col>
        </a-row>
        <footer-tool-bar>
            <a-button type="primary" @click="handleSubmit">保存</a-button>
            <a-button type="primary" ghost @click="goBackToList">
                <a-icon type="left" />返回列表
            </a-button>
        </footer-tool-bar>
    </div>
</template>

<script>
    import FooterToolBar from '../../components/FooterToolBar'
    export default {
        name: "AddTag",
        components:{
            FooterToolBar
        },
        beforeCreate () {
            this.form = this.$form.createForm(this);
        },
        data () {
            return {
                userInfo: '',
                content: '请输入内容',
                articleId: '',
                title: '',
                open: false,
                channelList: [],
                myform: {
                    channel: ''
                },
                form: this.$form.createForm(this),
                choosedReportId: '',
                choosedReportName: '',
            }
        },
        methods: {
            handleSubmit (e) {
                e.preventDefault()
                this.form.validateFields((err, values) => {
                    if (!err) {
                    } else {
                        return
                    }
                    this.title = values.title
                    var postData = {id: this.articleId, 'title': this.title, 'report_id': this.choosedReportId, 'user_id': this.userInfo.userid, 'adduser': this.userInfo.truename}
                    this.$http.post('api/assign/tagupdate', postData)
                        .then((res) => {
                            if (res.data.state === 200) {
                                // 发布成功 全部置空
                                this.form.resetFields()
                                this.choosedReportName = ''
                                this.choosedReportId = ''
                                this.$store.commit('storeIsSelectingReportAction', false)
                                this.$store.commit('storeChoosedTagInfo', {title: ''})
                                this.$store.commit('storeChoosedReportInfo', {id: '', name: ''})
                                if (this.articleId) {
                                    this.$message.success('修改成功')
                                } else {
                                    this.$message.success('发布成功')
                                }
                            }
                        })
                        .catch(() => {
                        })
                })
            },
            chooseReport () {
                this.title = this.form.getFieldValue('title')
                this.$store.commit('storeIsSelectingReportAction', true)
                this.$store.commit('storeChoosedTagInfo', {title: this.title})
                this.$router.push('/Main/Report/ReportList')
            },
            deleteReportInfo () {
                this.choosedReportName = ''
                this.choosedReportId = ''
                this.$store.commit('storeChoosedReportInfo', {id: '', name: ''})
            },
            goBackToList () {
                this.$router.push('/Main/Task/TagList')
            },
        },
        created () {
            this.userInfo = JSON.parse(localStorage.getItem('siteinfo'))
        },
        mounted () {
            this.title = this.$store.state.choosedTagInfo.title
            this.choosedReportName = this.$store.state.choosedReportInfo.name
            this.choosedReportId = this.$store.state.choosedReportInfo.id
            this.form.setFieldsValue({title: this.title})
        }
    }
</script>

<style scoped>
    .main {
        position: absolute;
        top: 42px;
        right: 0;
        bottom: 0;
        left: 0;
        overflow-y: auto;
        background-color: #fff;
        padding-left:10px;
    }
    .container{
        margin-top: 20px;
        margin-bottom: 56px;
    }
    .mgt10{
        margin-top: 10px;
    }
</style>
